<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <DrugSearchOutsource
          :companyId="companyId"
          :clearSelected="true"
          :companyDrugsOnly="drugs.length > 0"
          :onSelect="(drug) => addDrug(drug)"
        />
      </div>
    </div>
    <!--      <div class="col-md-4">-->
    <div class="mt-2">
      <div v-for="(d, i) in drugs">
        <div class="input-group">
          <input type="text" v-model="d.title" disabled class="form-control grow_input">
          <div class="input-group-prepend">
            <span class="input-group-text">Кол.</span>
          </div>
          <input type="text" v-model="d.requestQty" class="form-control">
          <div class="input-group-append">
              <span class="input-group-text">
              <i class="icon-fa icon-fa-rub"/>
              </span>
          </div>
          <input type="text" disabled v-model="d.price" class="form-control">
          <div class="input-group-append">
              <span class="input-group-text">
              Наличие&nbsp;<strong>{{ d.qty }}</strong>
              </span>
            <button @click="() => removeDrug(i)" class="btn btn-outline-danger">x</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="drugs.length" class="text-right mt-1">
      <LoadingButton
        title="Отправить"
        :loading="loading"
        :color="$constants.SUCCESS_COLOR"
        :onClick="() => sendRequest()"
        className="btn btn-outline-success"
      />
    </div>
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>

import DrugSearchOutsource from "@/components/drugs/DrugSearchOutsource";
import LoadingButton from "@/components/buttons/LoadingButton";
import api from "@/api";

export default {
  components: {LoadingButton, DrugSearchOutsource},
  props: ['companyId', 'clearOutsourceStore', 'clientData'],
  data() {
    return {
      drugs: [],
      loading: false,
      selectedDrug: null,
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
  methods: {
    removeDrug(index) {
      delete this.drugs[index];
      this.drugs = this.drugs.filter((d) => d);
    },
    addDrug(drug) {
      if (!drug) return;
      if (this.clearOutsourceStore && !this.drugs.length && !drug.company_id) {
        this.clearOutsourceStore(drug);
        return;
      }
      if (!this.drugs.find((d) => d.id === drug.id)) {
        this.drugs.push({...drug, requestQty: 1});
      } else {
        toastr['warning']('Препарат уже добавлен');
      }
    },
    async sendRequest() {
      if (!this.drugs.length) {
        toastr['warning']('Выберите препараты для заявки');
        return;
      }
      if (!this.clientData.client.name) {
        toastr['warning']('Укажите имя клиента');
        return;
      }
      if (!this.clientData.phones.find((p) => p.full_phone)) {
        toastr['warning']('Укажите телефон клиента');
        return;
      }
      this.loading = true;
      const {data} = await api.post('/telegram/sendMessage', {
        type: 'outsourceOrderMessage',
        company_id: this.companyId,
        client_data: this.clientData,
        drugs: this.drugs
      })
      if (data.success) {
        toastr['success']('Отправлено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.grow_input {
  width: 420px;
  /*flex-grow: 7;*/
}
</style>
